
import React, { memo } from 'react';
import { Button } from '@/components/ui/button';
import { Dumbbell, Terminal, RefreshCw } from 'lucide-react';

interface QuickActionButtonsProps {
  onNavigate: (path: string) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export const QuickActionButtons = memo(({ 
  onNavigate, 
  onRefresh, 
  isRefreshing 
}: QuickActionButtonsProps) => {
  return (
    <>
      {/* Lifting Tracker Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('/lifting')}
        className="win95-button flex items-center justify-center px-2 py-1 md:py-2 h-7 md:h-8 hover:bg-gray-200"
        title="Lifting Tracker"
      >
        <Dumbbell className="h-4 w-4" />
      </Button>
      
      {/* Monolith Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate('/monolith')}
        className="win95-button flex items-center justify-center px-2 py-1 md:py-2 h-7 md:h-8 hover:bg-gray-200"
        title="Monolith"
      >
        <Terminal className="h-4 w-4" />
      </Button>
      
      {/* Refresh Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={isRefreshing}
        className="win95-button flex items-center gap-2 text-xs md:text-sm px-2 md:px-3 py-1 md:py-2 h-7 md:h-8 hover:bg-gray-200"
      >
        <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
        <span className="hidden sm:inline">
          {isRefreshing ? 'Checking...' : 'Refresh'}
        </span>
      </Button>
    </>
  );
});

QuickActionButtons.displayName = 'QuickActionButtons';
